import * as React from "react"
import CountryDropdown from "@components/CountryDropdown"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { formatDate, formatCurrencyOnlySymbol } from "@utils/formatNumber"
import MaterialCardInfo from "@modules/PriceIndexPage/MaterialCardInfo"
import { slugMaterialName } from "../../../utils/helpers"

import aluminium_prices from "@images/aluminium_prices.png"
import copper_prices from "@images/copper_prices.png"
import brass_prices from "@images/brass_prices.png"
import stainless_steel_prices from "@images/stainless_steel_prices.png"
import iron_steel_prices from "@images/iron_steel_prices.png"
import lead_prices from "@images/lead_prices.png"
import zinc_prices from "@images/zinc_prices.png"
import tin_prices from "@images/tin_prices.png"

const ScrapMetalPriceIndex = ({
  availableCountries,
  allCountries,
  country,
  categoriesInfo,
  currentMaterial,
  locale = "en-DE",
  currency = "EUR",
  language,
  hideTitle = false,
}) => {
  const { t } = useTranslation()
  if (Array.isArray(currency)) currency = currency[0]

  const localisedPriceIndexDate = formatDate(new Date(), locale)

  const materialImages = {
    aluminium: aluminium_prices,
    copper: copper_prices,
    brass: brass_prices,
    "stainless-steel": stainless_steel_prices,
    "iron-and-steel": iron_steel_prices,
    lead: lead_prices,
    zinc: zinc_prices,
    tin: tin_prices,
  }

  return (
    <div className={`w-full flex justify-center bg-white`}>
      <div
        className={`
          
          flex
          flex-col
         
          gap-[16px]
          
          
          w-[347px]
          h-[1187px]
          
          justify-center
          items-start

          md:items-center
          md:h-[840px]
          md:w-[700px] 
           
          
          desk:gap-[24px]
          desk:w-[1348px] `}
      >
        {!hideTitle && (
          <span
            className={`
            text-dblue
            text-center
            font-inter
            font-medium
            leading-normal
            mb-[-8px]
             
            text-[20px]
            
            md:mb-[4px]

            desk:mb-[6px]
            desk:text-[40px]
            `}
          >
            {t("scrap_metal_price_index")}
          </span>
        )}

        <div
          className={`w-full
            flex
            
            justify-between
            md:items-center
            flex-col

            mb-[8px]
 
            md:mb-0
            md:flex-row`}
        >
          <span
            className={`
              text-bcoral
              leading-[150%]
              
              text-[14px]
              mb-[24px]

              md:mb-0
              desk:text-[16px]
              
              `}
          >
            {t("Scrap_Metal_Price*_Index")} - {localisedPriceIndexDate}
          </span>
          <CountryDropdown
            countryList={availableCountries}
            allCountries={allCountries}
            selectedCountry={country}
            material={currentMaterial ? currentMaterial.toLowerCase() : null}
            language={language}
          />
        </div>
        <div
          className={`
    flex
    flex-col
    justify-center
    gap-y-[16px]

    md:flex-wrap

    md:gap-y-[20px]
    md:gap-x-[16px]
    
    desk:gap-x-[32px]
    desk:gap-y-[16px]
    
    md:flex-row
    
    `}
        >
          {categoriesInfo.map(material => {
            let linkMaterialPage =
              language !== "en"
                ? `${process.env.GATSBY_SITE_URL}/${language}/scrap-metal-price/`
                : `${process.env.GATSBY_SITE_URL}/scrap-metal-price/`

            if (
              country.length > 0 &&
              country.toLowerCase() !== "international"
            ) {
              linkMaterialPage += `${slugMaterialName(country)}/`
            }

            linkMaterialPage += `${material.slug}/`

            const localisedLastPrice = formatCurrencyOnlySymbol(
              material.price,
              locale,
              currency
            )
            const localisedDate = formatDate(new Date(material.dt), locale)

            return (
              <div
                className={`
              flex-1 
              w-[350px]
    
              md:min-w-[332px] 
              md:max-w-[382px]

              desk:min-w-[572px] 
              desk:max-w-[572px]`}
              >
                <a href={linkMaterialPage}>
                  {" "}
                  <MaterialCardInfo
                    material={material.material}
                    date={localisedDate}
                    price={localisedLastPrice}
                    img={materialImages[material.slug]}
                    percentage={material.percentage}
                    currency={material.currency}
                    unit={material.unit}
                  />
                </a>
              </div>
            )
          })}
        </div>
        <div className="w-full">
          <span
            className={`text-bcoral
              font-inter
              text-[12px]
              font-normal
              leading-[150%]
              block

              md:mt-[4px]
              md:w-[448px]

              desk:w-[full]
              desk:mt-[0]
              `}
          >
            {t("Full-load-transactions")}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ScrapMetalPriceIndex
